<script lang="ts">
  import { getContext } from "svelte"
  import ModuleTypes from "../constants/ModuleTypes"
  import buildModuleUrl from "../lib/buildModuleUrl"
  import { buildUrlData } from "../lib/buildModuleUrlData"
  import ModuleContainer from "../components/ModuleContainer.svelte"
  import { productTypeForModuleType } from "../lib/Helpers"
  import { listenToIframeMessage } from "../lib/iframeMessaging"
  import type { Settings } from "website_script/types/settings"
  import type { Environment } from "website_script/types/environment"
  import type { ElementData } from "website_script/lib/Parsers"

  const settings = getContext<Settings>("settings")
  const { abTesting, trackFunction } = getContext<Environment>("environment")
  const moduleType = ModuleTypes.SIMILAR_CARS
  export let elementData: ElementData

  const trackType = productTypeForModuleType(moduleType)

  const urlBuildData = buildUrlData({
    settings,
    moduleType,
    abTesting: $abTesting,
    elData: elementData,
    departmentUuid: elementData.departmentId,
  })

  $: url = buildModuleUrl(urlBuildData)

  trackFunction(
    `Seen similar cars widget`,
    window.trackingConstants.eventTypeConstants.DISPLAYED_CTA,
    trackType
  )

  const redirectOnMessage = (messageData: {
    action: string
    redirectUrl: string
  }) => {
    if (messageData.action === "SimilarCarsWidget.redirect") {
      if (settings.similarCarsWidgetOpenNewTab) {
        window.open(messageData.redirectUrl)
      } else {
        setTimeout(() => {
          window.location.href = messageData.redirectUrl
        }, 300)
      }
    }
  }

  listenToIframeMessage(redirectOnMessage, /autouncle[a-z\-]*\.[a-z]+/, true)
</script>

<!--
@component
Loads similar cars widget in an iframe
-->
<ModuleContainer
  {moduleType}
  {url}
  moduleData={urlBuildData}
  locale={settings.locale}
  on:flowEvent
/>
